// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"6eef2184","213":"d4b4a970","453":"f1121fbb","586":"9ebcf4b3","690":"505cb51d","823":"c08996bd","881":"379c325b","928":"ff246311"}[chunkId] + ".chunk.js";
};